export default [
  {
    path: '/profile',
    name: 'profile-settings',
    component: () => import('@/views/account-setting/AccountSetting.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Configurações da Conta',
      action: 'read',
      resource: 'Auth',
      breadcrumb: [
        {
          text: 'Configurações da Conta',
          active: true,
        },
      ],
    },
  },
]
